import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AlertService, ResourceService, TokenService, sceconfig } from 'sce-core';
import { environment } from '../environments/environment';
import { LoggerService } from './core/logger.service';
import { PTW_SERVICE_URL } from './constants';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private injector: Injector;
  public jReportUrl: any;
  private hostOverride: string | null = null; // test override

  // Test-only setters/getters to allow mocking hostname without redefining window.location
  public setHostForTest(host: string) { this.hostOverride = host; }
  private getHostname(): string { return this.hostOverride || window.location.hostname; }

  constructor(injector: Injector) {
    this.injector = injector; // Used to avoid cyclic error for AuthService<-->HttpClient
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // To avoid cyclic dependency error, do not Initiate AuthService in constructor.Instead inject it here
    const tokenService: TokenService = this.injector.get(TokenService);
    //checking the jreport url based on the environment
    //the url for each environment is mentioned in configfile
    const hostname = this.getHostname();
    if (hostname.includes(sceconfig.wms.wmsCdtDigital)) { //for feature branches
      this.jReportUrl = sceconfig.wms.wmsJreportBaseCdt;
    }
    else {
      switch (hostname) {
        case sceconfig.wms.wmsProdAmericas:
          this.jReportUrl = sceconfig.wms.wmsJreportBaseProdAmericas;
          break;
        case sceconfig.wms.wmsProdAsia:
          this.jReportUrl = sceconfig.wms.wmsJreportBaseProdAsia;
          break;
        case sceconfig.wms.wmsProdEur:
          this.jReportUrl = sceconfig.wms.wmsJreportBaseProdEur;
          break;
        case sceconfig.wms.wmsMaerskEurProd:
          this.jReportUrl = sceconfig.wms.wmsJreportBaseMaerskEurProd;
          break;
        case sceconfig.wms.wmsMaerskLamProd:
          this.jReportUrl = sceconfig.wms.wmsJreportBaseMaerskLamProd;
          break;
        case sceconfig.wms.wmsCdt:
          this.jReportUrl = sceconfig.wms.wmsJreportBaseCdt;
          break;
        case sceconfig.wms.wmsStage:
          this.jReportUrl = sceconfig.wms.wmsJreportBaseStage;
          break;
        case sceconfig.wms.wmsStageAsia:
          this.jReportUrl = sceconfig.wms.wmsJreportBaseStageAsia;
          break;
        case sceconfig.wms.wmsStageAmericas:
          this.jReportUrl = sceconfig.wms.wmsJreportBaseStageAmericas;
          break;
        case sceconfig.wms.wmsPreProd:
          this.jReportUrl = sceconfig.wms.wmsJreportBasePreProd;
          break;
        case sceconfig.wms.wmsUat:
          this.jReportUrl = sceconfig.wms.wmsJreportBaseUat;
          break;
        case sceconfig.wms.wmsAliCloudProd:
          this.jReportUrl = sceconfig.wms.wmsJreportAliCloudProd;
          break;
        case sceconfig.wms.wmsAliCloudUat:
          this.jReportUrl = sceconfig.wms.wmsJreportAliCloudUat;
          break;
        case sceconfig.wms.wmsAliCloudSit:
          this.jReportUrl = sceconfig.wms.wmsJreportAliCloudUat;
          break;
        default:
          this.jReportUrl = sceconfig.wms.wmsJreportBaseUrl;
          break;
      }
    }
    
    // LFWM-2028-To handle the JReport api requests
    // append the header with content type- application/x-www-form-urlencoded
    // and withCredentials true 
    if (req.url.startsWith(this.jReportUrl) ) {
     const accessToken = tokenService.getAccessToken();
      let reqHeadersJReport = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded',});
      if(accessToken != null) reqHeadersJReport = reqHeadersJReport.set( 'Authorization',accessToken);
      const authReqJReport = req.clone({
        url: req.url,
        headers: reqHeadersJReport,
        withCredentials: true,
      });
      return next.handle(authReqJReport);
    }

    const isPTWRequest = req.url.startsWith(PTW_SERVICE_URL.PTW_AUTHZ_URL_CDT) || req.url.startsWith(PTW_SERVICE_URL.PTW_SERVICE_URL) || req.url.startsWith(PTW_SERVICE_URL.PTW_AUTHZ_URL_STAGE) || req.url.startsWith(PTW_SERVICE_URL.PTW_SERVICE_URL_STAGE)  || req.url.startsWith(PTW_SERVICE_URL.PTW_SERVICE_URL_PROD) || req.url.startsWith(PTW_SERVICE_URL.PTW_AUTHZ_URL_PROD) || req.url.startsWith(PTW_SERVICE_URL.CONFIGWIZ_SERVICE_URL) || req.url.startsWith(PTW_SERVICE_URL.CONFIGWIZ_STAGE_SERVICE_URL);

    if (isPTWRequest) {
      const fbMToken = tokenService.getFbMToken();
      let ptwHeaders = req.headers.set('Authorization', `Bearer ${fbMToken}`);
      ptwHeaders = ptwHeaders.set('Content-Type', 'application/json');
  
      const authReqPTW = req.clone({
        headers: ptwHeaders,
      });
  
      return next.handle(authReqPTW);
    }
    // ******************** API based url prefix logic **********************
    let appFullUrl = req.url;
    // if the given URL is full, do not append the prefix again
    if (!req.url.startsWith('http')) {

            switch (req.headers.get('api') ) {
              case 'admin' :  // any calls from admin module will be routed through here.
                            // ** Currently only added in getAllUsers() in userService -- /api/users. refer for example usage.
                           // console.log('admin api caught in interceptor - inject conditional prefix here' , req.url, req.headers);
                            appFullUrl = sceconfig.wms.commonApiBaseUrl + appFullUrl; 
                            break;
              case 'dashboard':  // any calls from dashboard module will be routed through here.
                            appFullUrl = sceconfig.dashboard.dashboardApiBaseUrl + appFullUrl;
                            break;
              case 'scecommon':  // UPW-37501 Direct SCECommonService API Call 
                            appFullUrl = environment.commonApiBaseUrl + appFullUrl;
                            break;
          //    case 'wms'   : break; // any wms specific logic
          //    case 'gvt'   : break; // any gvt specific logic
              default      :  // consider all default as appUrl wms/gvt etc
                            appFullUrl = environment.wmsApiBaseUrl + appFullUrl;
            }
    }
    // ******************** API based url prefix logic  ENDS *****************


    // Define API URLs that should bypass authorization [UWP-31309]
    const bypassAuthUrls = [
      sceconfig.wms.wmsCdtFbmRefreshToken,
      sceconfig.wms.wmsStageFbmRefreshToken,
      sceconfig.wms.wmsProdFbmRefreshToken
    ];

    // Check if the request URL matches any of the bypassAuthUrls
    const shouldBypassAuth = bypassAuthUrls.some(url => req.url.startsWith(url));

    // Set the initial headers without Authorization if bypass is needed
    let reqHeaders = new HttpHeaders();

    // Only add Authorization if the URL is NOT in the bypass list
    if (!shouldBypassAuth) {
      reqHeaders = reqHeaders.set('Authorization', tokenService.getToken());
    }

    // Set the content type
    const contentType = req.headers.get('Content-Type') || 'application/json';
    if (contentType !== 'application/octet-stream') {
      reqHeaders = reqHeaders.set('Content-Type', contentType);
    }

    // Set Accept
    const acceptType = req.headers.get('Accept') || 'application/json';
    reqHeaders = reqHeaders.set('Accept', acceptType);

    // Set Azure Token if present
    if (req.headers.has('AzureToken')) {
      reqHeaders = reqHeaders.set('AzureToken', req.headers.get('AzureToken'));
    }
    // Clone the request to add the new header.
    const authReq = req.clone({
      url: appFullUrl,
      headers: reqHeaders
    });
    // Pass on the cloned request instead of the original request.
    return next.handle(authReq);
  }
}

@Injectable()
export class TimingLogInterceptor implements HttpInterceptor {

  constructor(private _logger: LoggerService) { }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const started = Date.now();
    return next
      .handle(req)
      ._finally(() => {
        const elapsed = Date.now() - started;
        // this._logger.debug(`Request for ${req.urlWithParams} took ${elapsed} ms.`);
      });
  }
}

@Injectable()
export class ResponseErrorInterceptor implements HttpInterceptor {

  constructor(
    private readonly _logger: LoggerService,
    private readonly injector: Injector
  ) { }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .catch((error: any) => {
        if(!JSON.stringify(req).includes("password")){
          let log  = "Request for\n ="+JSON.stringify(req)+"\t"+ "\nError\n"+ JSON.stringify(error);
          this._logger.errorLog.push(log); 
        }
        const timeoutOccurred = (
          error instanceof HttpErrorResponse &&
          error.status === 504
        );
        if (timeoutOccurred) {
          const alertService: AlertService = this.injector.get(AlertService);
          const resourceService: ResourceService = this.injector.get(ResourceService);
          setTimeout(() => {
            alertService.clearAll().warn(resourceService.get('msg_gateway_timeout'));
          }, 100);
        }
        return Observable.throw(error);
      });
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/http.interceptor.ts